'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagSiAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M0.972348 0H29V20H0.972348V0Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.999997 13.3333H29L29 6.66667H10.244V5.33333C10.244 5.33333 9.30367 4.66667 8.33333 4.66667C7.36299 4.66667 6.33333 5.33333 6.33333 5.33333V6.66667H0.966553L0.999997 13.3333ZM9.66666 8C9.66666 8.73638 9.06971 9.33333 8.33333 9.33333C7.59695 9.33333 7 8.73638 7 8C7 7.26362 7.59695 6.66667 8.33333 6.66667C9.06971 6.66667 9.66666 7.26362 9.66666 8Z",
          fill: "#0C47B7"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.999997 20H29V13.3333H0.999997V20Z",
          fill: "#E53B35"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M29 0L29 6.65284H28.5V0.5H1.5L1.5 6.65284H1L1.00003 0H29Z",
          fill: "#949494"
        }
      )
    ]
  }
);
const VpFlagSiAsset = forwardRef(FlagSiAsset);

export { VpFlagSiAsset as default };
